// src/AddCommander.js
import React, { useState, useEffect, useContext } from 'react';
import axiosInstance from '../utils/axiosInstance';
import { API_URL } from '../utils/runtimeConfig';
import './css/AddCommanderModal.css';
import { AuthContext } from '../context/AuthContext';
import { ErrorContext } from '../context/ErrorContext';
import NationSelector from '../components/NationSelector';

const apiUrl = API_URL

const AddCommanderModal = ({ onCommanderAdded }) => {
  const axios = axiosInstance
  const { showError } = useContext(ErrorContext);
  const { user } = useContext(AuthContext);
  const getNationId = (nationValue) => {
    if (!nationValue) return '';
    if (typeof nationValue === 'object') {
      return String(nationValue._id || nationValue.id || '');
    }
    return String(nationValue);
  };

  const [nations, setNations] = useState([])
  const [selectedNation, setSelectedNation] = useState(user.nation)
  const [name, setName] = useState('');
  const [battlePower, setBattlePower] = useState('');
  const [language, setLanguage] = useState('');
  const [alliances, setAlliances] = useState([]);
  const [selectedAlliance, setSelectedAlliance] = useState('');

  useEffect(() => {
    const fetchAlliances = async () => {
      try {
        const allNations = await axios.get(`${apiUrl}/nations`);
        setNations(allNations.data)

        const nationId = getNationId(selectedNation) || getNationId(user?.nation);
        if (!nationId) {
          setAlliances([]);
          return;
        }
        const nationAlliances = await axios.get(`${apiUrl}/nations/${nationId}/alliances`);
        setAlliances(nationAlliances.data);
      } catch (error) {
        console.error('Error fetching alliances:', error);
      }
    };

    fetchAlliances();
  }, [axios, selectedNation, user?.nation]);

  const handleAddCommander = async () => {
    try {
      const nationId = getNationId(selectedNation) || getNationId(user?.nation);
      if (!nationId) {
        showError('Unable to determine nation for new commander.');
        return;
      }
      const newCommander = {
        nation: nationId,
        name,
        battlePower,
        language,
        alliance: selectedAlliance || null,
      };
      await axios.post(`${apiUrl}/nations/${nationId}/commanders`, newCommander);
      onCommanderAdded();
      setName('');
      setBattlePower('');
      setLanguage('');
      setSelectedAlliance('');
    } catch (error) {
      console.error('Error adding commander:', error);
      showError (error)
    }
  };

  const handleBattlePowerChange = (e) => {
    // Remove any non-numeric characters (like commas) before storing the value
    const rawValue = e.target.value.replace(/\D/g, '');
    setBattlePower(rawValue);
  };

  const formatNumber = (value) => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <div className="add-commander">
      <h2>Add Commander</h2>
      <NationSelector
        nations={nations}
        selectedNation={selectedNation}
        setSelectedNation={setSelectedNation}
      />

      <div className="add-commander-form">
        <label htmlFor="add-commander-name">
          Name
        </label>
        <input
          id="add-commander-name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <label htmlFor="add-commander-bp">
          Battle Power
        </label>
        <input
          id="add-commander-bp"
          type="text"
          value={formatNumber(battlePower)}
          onChange={handleBattlePowerChange}
          onBlur={(e) => setBattlePower(e.target.value.replace(/,/g, ''))}
        />

        <label htmlFor="add-commander-alliance">
          Alliance
        </label>
        <select
          id="add-commander-alliance"
          value={selectedAlliance}
          onChange={(e) => setSelectedAlliance(e.target.value)}
        >
          <option value="">None</option>
          {alliances.map((alliance) => (
            <option key={alliance._id} value={alliance._id}>
              {alliance.name} ({alliance.acronym})
            </option>
          ))}
        </select>

        <label htmlFor="add-commander-language">
          Language
        </label>
        <input
          id="add-commander-language"
          type="text"
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
          placeholder="e.g. english"
        />

        <button onClick={handleAddCommander}>Add Commander</button>
      </div>
    </div>
  );
};

export default AddCommanderModal;
